/**
 * 设备储能
 */
export class NewcomerHigherOutput {
    constructor({el}) {
        this.DOM = {
            cls: el,
            el: $(el)
        }
        if ($(this.DOM.cls).length === 0) {
            return;
        }
        this.init();
    }
    init(){
        $(`${this.DOM.cls} .higher-btn`).on('click',function(){
            $('.newcomer-main-pop').css('display', 'block');
            $('body').css('overflow', 'hidden');
            if(window.innerWidth < 1024) {
                setTimeout(() => {
                    $('.newcomer-main-pop .higher-output-box').css('transform', 'translateY(0)');
                }, 50);
            }
        })
        $('.pop-close-icon').on('click',function(){
            $('.newcomer-main-pop').css('display', 'none');
            $('body').css('overflow', 'auto');
            if(window.innerWidth < 1024) {
               $('.newcomer-main-pop .higher-output-box').css('transform', 'translateY(100%)');
            }
        })
    }
}
